module.exports = __webpack_public_path__ + "img/25.3.TP.9bc170ee.png";